import React, { useEffect, useReducer} from 'react';
import {Input, Label} from './FormControls';
import StateSelect from './StateSelect';
import tw from 'twin.macro';
import { update } from 'lodash';

const addressReducer = (state, action) => {
    switch (action.type) {
        case 'updateField':
            return Object.assign({}, state, action.payload)   
        default:
            throw new Error()
    }
}

const AddressInputs = ({id, dispatch, required }) => {

    useEffect(()=> {
        // update country on mount
        dispatch({ type: 'updateField', key: `input_${id}_5`, value: 'United States'})
    }, [])
    
    const [addressState, dispatchAddressState] = useReducer(addressReducer, {
        street: '',
        city: '',
        state: '',
        zipCode: '',
    })

    const updateField = (e) => {
        // assign payload value

        const payload = ({
            [e.target.getAttribute('data-fieldName')] : e.target.value,
        })

        dispatchAddressState({
            type: 'updateField',
            payload,
        });

        dispatch({  
            type: 'updateField', 
            key: e.target.getAttribute('data-wp-input-id'),
            value: e.target.value,
        });

    }

    return (
        <div tw="md:(grid grid-cols-3 col-gap-4) mt-5">

            {/* Street Address */}
            <div tw="col-span-3">

                <Label for="street-address">Street Address</Label>
                <Input
                    id="street-address"
                    data-fieldName="street"
                    data-wp-input-id={`input_${id}_1`}
                    onChange={updateField} 
                    autocomplete="shipping street-address"
                />
            </div>
            {/* City */}
            <div>
                <Label for="city">City</Label>
                <Input 
                    id="city"
                    data-fieldName="city"
                    data-wp-input-id={`input_${id}_3`}
                    onChange={updateField} 
                    autocomplete="shippin street-locality"
                    
                />
            </div>

            {/* State */}
            <div>
                <Label for="state">State</Label>
                <StateSelect
                    id="state"
                    data-fieldName="state"
                    data-wp-input-id={`input_${id}_4`}
                    onChange={updateField} 
                    autocomplete="shiopping region"
                />
            </div>

            {/* zipCode */}
            <div>
                <Label for="zipcode">Zip Code</Label>
                <Input 
                    id="zipCode"
                    data-fieldName="zipCode"
                    data-wp-input-id={`input_${id}_6`}
                    onChange={updateField}
                    pattern="\d{5}"
                    maxLength={5}

                    autocomplete="shipping postal-code"
                />
            </div>
        
        </div>
    )
}

export default AddressInputs